import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

import { RangePicker } from '@lmc/ui-kit'

const handleDateChange = (props: any) => {
  const { dates, setEndDate, setStartDate } = props

  if (!dates) {
    setStartDate(dayjs().subtract(14, 'days').startOf('day'))
    setEndDate(dayjs())
  } else {
    setStartDate(dates[0].startOf('day'))
    setEndDate(dates[1].endOf('day'))
  }
}

export default function StockDiscrepanciesDateFilter(props: any) {
  const { endDate, startDate, setEndDate, setStartDate } = props

  return (
    <RangePicker
      defaultValue={[startDate, endDate]}
      onChange={(dates) =>
        handleDateChange({ setEndDate, setStartDate, dates })
      }
    />
  )
}

StockDiscrepanciesDateFilter.propTypes = {
  endDate: PropTypes.object.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  startDate: PropTypes.object.isRequired,
}
